<template>
    <div>
        <material-card class="card-tabs" color="green">
            <v-progress-linear
                v-if="transactionsLoading"
                :indeterminate="true"
                color="success"
            ></v-progress-linear>
            <v-flex slot="header">
                <v-tabs
                    v-model="activeTab"
                    color="transparent"
                    slider-color="white"
                >
                    <!-- <span
                        class="subheading font-weight-light mr-3"
                        style="align-self: center"
                        >Transactions:</span
                    > -->
                    <v-tab class="mr-3" href="#all">
                        All
                    </v-tab>
                    <v-tab class="mr-3" href="#bills">
                        Bills
                    </v-tab>
                    <v-tab class="mr-3" href="#payments">
                        Payments
                    </v-tab>
                    <v-tab class="mr-3" href="#registration">
                        Registration
                    </v-tab>
                    <v-tab class="mr-3" href="#students">
                        Students
                    </v-tab>
                    <v-spacer></v-spacer>

                    <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 px-3 mr-2"
                        v-if="currentRegID == regID"
                        @click="openRegisterDialog()"
                        >Register</v-btn
                    >
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                style="color: #4caf50; background-color: #FFF"
                                class="ma-0 px-3"
                                v-on="on"
                                :loading="downloading"
                            >
                                Statements
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile
                                v-for="(action, index) in getStatementActions()"
                                :key="index"
                                @click="action.action"
                            >
                                <v-list-tile-title>{{
                                    action.text
                                }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <!-- <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 px-3 ml-2"
                        v-if="currentRegID == regID"
                        @click="addStudent"
                        >Add Student</v-btn
                    > -->
                    <!-- <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 px-3 ml-2"
                        v-if="currentRegID == regID"
                        @click="openNewCreditCardModal()"
                        >New Credit Card</v-btn
                    > -->
                    <!-- <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 ml-2 px-3"
                        @click="openSendMessageDialog"
                        >Message</v-btn
                    > -->
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                style="color: #4caf50; background-color: #FFF"
                                class="ma-0 ml-2 px-3"
                                v-on="on"
                            >
                                Message
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile
                                v-for="(action, index) in getMessageActions()"
                                :key="index"
                                @click="action.action"
                            >
                                <v-list-tile-title>{{
                                    action.text
                                }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-btn
                        style="color: #4caf50; background-color: #FFF"
                        class="ma-0 ml-2 px-3"
                        @click="openPaymentModal"
                        >Make Payment</v-btn
                    >
                </v-tabs>
            </v-flex>

            <v-tabs-items v-model="activeTab">
                <v-tab-item
                    v-for="tab in [
                        'all',
                        'bills',
                        'payments',
                        'registration',
                        'students',
                    ]"
                    :key="tab"
                    :value="tab"
                >
                    <v-btn
                        v-if="['all', 'bills'].includes(activeTab)"
                        color="success"
                        small
                        class="mt-0"
                        @click="openAddChargeDialog"
                        >Add Charge</v-btn
                    >
                    <v-expansion-panel
                        v-if="['all', 'bills', 'payments'].includes(tab)"
                    >
                        <v-expansion-panel-content
                            class=""
                            v-for="transaction in getTabList()"
                        >
                            <template v-slot:header class="my-0">
                                <v-layout row style="padding-top: 13px;">
                                    <v-tooltip left content-class="left">
                                        <v-btn
                                            slot="activator"
                                            class="v-btn--simple"
                                            icon
                                            style="margin-bottom: 0px; margin-top: 6px;"
                                        >
                                            <v-icon
                                                class="mr-3 ml-1"
                                                dark
                                                style="font-size: 24px;"
                                                :color="
                                                    getStatusIconColor(
                                                        transaction,
                                                    )
                                                "
                                                >{{
                                                    getStatusIcon(transaction)
                                                }}</v-icon
                                            >
                                        </v-btn>
                                        <span>{{
                                            getTransactionStatus(transaction)
                                        }}</span>
                                    </v-tooltip>

                                    <div>
                                        <v-layout row class="pa-0 ma-0">
                                            <div class="subheading mb-1">
                                                {{
                                                    getTransactionTitle(
                                                        transaction,
                                                    )
                                                }}
                                            </div>
                                        </v-layout>
                                        <div
                                            class="text--disabled subheading"
                                            v-if="transaction.txnType == 'D'"
                                        >
                                            {{ getStudentInfo(transaction) }}
                                        </div>
                                        <div
                                            class="text--disabled subheading"
                                            v-if="transaction.txnType == 'C'"
                                        >
                                            {{
                                                getPaymentDescription(
                                                    transaction,
                                                )
                                            }}
                                        </div>
                                    </div>
                                </v-layout>
                                <v-spacer></v-spacer>
                                <div
                                    class="text--disabled body-2"
                                    v-if="transaction.note"
                                >
                                    {{ truncateText(transaction.note) }}
                                </div>
                                <div
                                    class="text--disabled body-2"
                                    v-if="
                                        transaction.txnType == 'D' &&
                                            transaction.description.startsWith(
                                                'Yeshiva Ketana Camp',
                                            ) &&
                                            transaction.student.cardPrinted
                                    "
                                >
                                    Card Is Printed
                                </div>
                                <div
                                    class="text-danger subheading"
                                    v-if="
                                        transaction.txnType == 'C' &&
                                            transaction.payment &&
                                            transaction.payment.isVoided
                                    "
                                >
                                    VOIDED
                                </div>
                                <div
                                    class="text-danger subheading"
                                    v-if="isDeclined(transaction)"
                                >
                                    DECLINED
                                </div>
                                <div
                                    class="text-danger subheading"
                                    v-if="isError(transaction)"
                                >
                                    ERROR
                                </div>
                                <v-spacer></v-spacer>
                                <div
                                    class="subheading text-xs-right pr-3"
                                    v-bind:class="{
                                        'width-70': tab == 'all',
                                        'text-danger':
                                            transaction.txnType == 'C',
                                        'text-success':
                                            transaction.txnType == 'D',
                                    }"
                                >
                                    {{ getTransactionAmount(transaction) }}
                                </div>
                                <div
                                    class="body-2 text-xs-right pr-3 width-70"
                                    style="color: rgb(103 92 92);"
                                    v-if="tab == 'all'"
                                >
                                    {{ transaction.balance | currency }}
                                </div>
                            </template>
                            <v-card>
                                <v-flex xs12>
                                    <div v-if="transaction.txnType == 'C'">
                                        <v-card-text class="subheading mt-2">
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.dateCreated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Date Added:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.dateCreated
                                                            | time
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Payment Type:
                                                </div>
                                                <div>
                                                    {{
                                                        getPaymentType(
                                                            transaction,
                                                        )
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Date:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.date | date
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-for="prop in getProperties(
                                                    transaction,
                                                )"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    {{ prop.name }}:
                                                </div>
                                                <div>
                                                    {{ prop.value }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.lastUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.lastUpdated
                                                            | time
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.userUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated By:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.userUpdated
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.doNotShow"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Hide Transaction:
                                                </div>
                                                <div>
                                                    {{ transaction.doNotShow }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    hasSchedule(
                                                        transaction.schedules,
                                                    )
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Schedule Date:
                                                </div>
                                                <div>
                                                    {{
                                                        getScheduleDate(
                                                            transaction.schedules,
                                                        ) | time
                                                    }}
                                                </div>
                                            </v-layout>

                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="
                                                    hasSchedule(
                                                        transaction.schedules,
                                                    )
                                                "
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Schedule Enabled:
                                                </div>
                                                <div>
                                                    {{
                                                        getEnabledStatus(
                                                            transaction.schedules,
                                                        )
                                                    }}
                                                </div>
                                            </v-layout>

                                            <transaction-payment-details
                                                :transaction="transaction"
                                            ></transaction-payment-details>

                                            <div
                                                v-if="
                                                    getCheckDetails(transaction)
                                                        .length
                                                "
                                                class="pl-1 py-2"
                                            >
                                                <div
                                                    class="font-weight-medium mb-2"
                                                >
                                                    Check Details:
                                                </div>
                                                <v-layout
                                                    row
                                                    class="px-3 py-1"
                                                    v-for="detail in getCheckDetails(
                                                        transaction,
                                                    )"
                                                >
                                                    <div
                                                        v-if
                                                        class="font-weight-regular mr-2"
                                                    >
                                                        Check #
                                                        {{ detail.checkNumber }}
                                                        -
                                                    </div>
                                                    <div
                                                        class="font-weight-medium"
                                                    >
                                                        {{
                                                            detail.amount
                                                                | currency
                                                        }}
                                                    </div>
                                                </v-layout>
                                            </div>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-layout row class="mb-2 pr-1">
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    small
                                                    outline
                                                    color="success"
                                                    @click="
                                                        openEmailReceiptDialog(
                                                            transaction,
                                                        )
                                                    "
                                                >
                                                    Email Receipt
                                                </v-btn>
                                                <v-btn
                                                    small
                                                    outline
                                                    color="success"
                                                    :loading="
                                                        downloadingReceipt
                                                    "
                                                    @click="
                                                        printReceipt(
                                                            transaction,
                                                        )
                                                    "
                                                >
                                                    Print Receipt
                                                </v-btn>
                                                <div
                                                    class="lapidus-transaction-button ml-2"
                                                >
                                                    <v-btn
                                                        small
                                                        dark
                                                        color="default"
                                                        v-if="
                                                            allowRefund(
                                                                transaction,
                                                            )
                                                        "
                                                        @click="
                                                            voidPayment(
                                                                transaction,
                                                            )
                                                        "
                                                    >
                                                        Refund/Void Payment
                                                    </v-btn>
                                                    <v-btn
                                                        small
                                                        dark
                                                        color="default"
                                                        class=""
                                                        v-if="
                                                            ![
                                                                'Refund',
                                                                'Void',
                                                                'Country Voucher',
                                                            ].includes(
                                                                getPaymentType(
                                                                    transaction,
                                                                ),
                                                            )
                                                        "
                                                        @click="
                                                            updatePayment(
                                                                transaction,
                                                            )
                                                        "
                                                    >
                                                        Update Payment
                                                    </v-btn>
                                                    <v-btn
                                                        small
                                                        dark
                                                        color="default"
                                                        v-if="
                                                            ![
                                                                'CC',
                                                                'CK',
                                                                'Refund',
                                                                'Void',
                                                                'ACH',
                                                            ].includes(
                                                                getPaymentType(
                                                                    transaction,
                                                                ),
                                                            )
                                                        "
                                                        @click="
                                                            deletePayment(
                                                                transaction,
                                                            )
                                                        "
                                                    >
                                                        Delete Payment
                                                    </v-btn>
                                                    <v-btn
                                                        small
                                                        dark
                                                        color="default"
                                                        v-if="
                                                            [
                                                                'CC',
                                                                'ACH',
                                                                'CK',
                                                            ].includes(
                                                                getPaymentType(
                                                                    transaction,
                                                                ),
                                                            ) &&
                                                                isLaterDate(
                                                                    transaction.date,
                                                                )
                                                        "
                                                        @click="
                                                            cancelScheduledPayment(
                                                                transaction,
                                                            )
                                                        "
                                                    >
                                                        Cancel Scheduled Payment
                                                    </v-btn>
                                                </div>
                                            </v-layout>
                                        </v-card-actions>
                                    </div>

                                    <div v-else>
                                        <v-card-text class="subheading mt-2">
                                            <v-layout row class="px-3 py-2">
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Date:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.date | date
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-for="prop in getProperties(
                                                    transaction,
                                                )"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    {{ prop.name }}:
                                                </div>
                                                <div>
                                                    {{ prop.value }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.lastUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.lastUpdated
                                                            | time
                                                    }}
                                                </div>
                                            </v-layout>
                                            <v-layout
                                                row
                                                class="px-3 py-2"
                                                v-if="transaction.userUpdated"
                                            >
                                                <div
                                                    class="font-weight-medium mr-2"
                                                >
                                                    Last Updated By:
                                                </div>
                                                <div>
                                                    {{
                                                        transaction.userUpdated
                                                    }}
                                                </div>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <!-- <v-layout column>
                                                <div
                                                    v-for="document in getDocumentsForStudent(
                                                        transaction.student
                                                    )"
                                                >
                                                    <v-btn
                                                        class="mt-2 ml-2 px-3"
                                                        @click="
                                                            openDocument(
                                                                document
                                                            )
                                                        "
                                                    >
                                                        <v-icon
                                                            color="red"
                                                            left
                                                            dark
                                                            >mdi-file-pdf</v-icon
                                                        >
                                                        {{
                                                            document.category +
                                                                " - " +
                                                                document.uploadedOn
                                                        }}
                                                        <v-icon right
                                                            >mdi-download</v-icon
                                                        >
                                                    </v-btn>
                                                    <v-btn
                                                        :disabled="
                                                            currentRegID !=
                                                                regID
                                                        "
                                                        small
                                                        icon
                                                        @click.stop="
                                                            deleteDocument(
                                                                document
                                                            )
                                                        "
                                                        ><v-icon color="red"
                                                            >mdi-delete-forever</v-icon
                                                        ></v-btn
                                                    >
                                                </div>
                                            </v-layout> -->
                                            <v-spacer></v-spacer>
                                            <!-- <v-btn
                                                small
                                                :disabled="
                                                    currentRegID != regID
                                                "
                                                v-if="
                                                    transaction.description.startsWith(
                                                        'Yeshiva Ketana Camp'
                                                    )
                                                "
                                                color="blue-grey"
                                                class="white--text mr-2"
                                                @click="
                                                    openUploadDocumentDialog(
                                                        transaction.student
                                                    )
                                                "
                                            >
                                                Upload Document
                                                <v-icon right dark
                                                    >mdi-cloud-upload</v-icon
                                                >
                                            </v-btn> -->
                                            <!-- <v-btn
                                                :disabled="
                                                    currentRegID != regID
                                                "
                                                small
                                                dark
                                                color="default"
                                                class="mr-2"
                                                v-if="
                                                    transaction.student.nonUTA
                                                "
                                                @click="
                                                    editStudentInfo(
                                                        transaction.student,
                                                    )
                                                "
                                            >
                                                Update Student
                                            </v-btn> -->
                                            <v-btn
                                                small
                                                dark
                                                color="default"
                                                v-on:click="
                                                    openEditAmountDialog(
                                                        transaction,
                                                    )
                                                "
                                            >
                                                Update
                                            </v-btn>

                                            <v-btn
                                                small
                                                dark
                                                color="default"
                                                v-if="allowDeleting()"
                                                v-on:click="
                                                    deleteCharge(transaction)
                                                "
                                            >
                                                Delete Charge
                                            </v-btn>
                                        </v-card-actions>
                                    </div>
                                </v-flex>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <div v-if="tab == 'registration'">
                        <div class="title mb-4 pt-2 text-xs-center">
                            REGISTRATION
                        </div>
                        <div v-for="student in enrolledStudents">
                            <v-layout class="pa-3 mb-2 " row>
                                <div class="font-weight-regular title">
                                    {{ student.firstNameH }}
                                </div>
                                <div class="mx-2"></div>
                                <div
                                    class="font-weight-regular title "
                                    v-bind:class="{
                                        'darken-1 green--text text--darken-1':
                                            student.registrationStatus ==
                                            'REGISTERED',
                                        'darken-1 red--text text--darken-1':
                                            student.registrationStatus ==
                                            'NOT REGISTERED',
                                    }"
                                >
                                    {{ student.registrationStatus }}
                                </div>
                            </v-layout>
                            <div
                                v-if="student.requirments"
                                v-for="(requirment,
                                index) in student.requirments.filter(
                                    (r) => r.showRequirment,
                                )"
                            >
                                <v-layout
                                    class="px-3 py-2"
                                    row
                                    justify-space-between
                                >
                                    <div class="font-weight-regular">
                                        {{
                                            requirment.description +
                                                " - " +
                                                requirment.status
                                        }}
                                    </div>
                                    <v-spacer></v-spacer>
                                    <!-- <div
                                        v-if="
                                            allowUpload(requirment.status) &&
                                                hasCopy(requirment)
                                        "
                                    >
                                        <v-btn
                                            small
                                            outline
                                            color="blue-grey"
                                            class="mr-2 my-0"
                                            @click="
                                                openCopyDocumentDialog(
                                                    student,
                                                    requirment
                                                )
                                            "
                                        >
                                            Import Old Document
                                        </v-btn>
                                    </div> -->
                                    <v-btn
                                        v-if="
                                            allowUpload(requirment.status) &&
                                                requirment.description !=
                                                    'Insurance / Medicaid Card'
                                        "
                                        small
                                        color="blue-grey"
                                        class="mr-2 my-0 white--text"
                                        @click="download(requirment, student)"
                                    >
                                        Download
                                    </v-btn>
                                    <div v-if="allowUpload(requirment.status)">
                                        <v-btn
                                            small
                                            color="blue-grey"
                                            class="mr-2 my-0 white--text"
                                            @click="
                                                openUploadDocumentDialog(
                                                    student,
                                                    requirment,
                                                )
                                            "
                                        >
                                            Upload
                                        </v-btn>
                                    </div>
                                </v-layout>
                                <v-layout column>
                                    <div
                                        v-for="document in getDocuments(
                                            student,
                                            requirment,
                                        )"
                                    >
                                        <v-btn
                                            class="mt-2 ml-2 px-3"
                                            @click="openDocument(document)"
                                        >
                                            <v-icon color="red" left dark
                                                >mdi-file-pdf</v-icon
                                            >
                                            {{
                                                document.category +
                                                    " - " +
                                                    document.uploadedOn
                                            }}
                                            <v-icon right>mdi-download</v-icon>
                                        </v-btn>
                                        <v-btn
                                            :disabled="currentRegID != regID"
                                            small
                                            icon
                                            @click.stop="
                                                deleteDocument(document)
                                            "
                                            ><v-icon color="red"
                                                >mdi-delete-forever</v-icon
                                            ></v-btn
                                        >
                                    </div>
                                </v-layout>
                                <v-divider
                                    class="py-2"
                                    v-if="
                                        student.requirments &&
                                            index + 1 <
                                                student.requirments.filter(
                                                    (r) => r.showRequirment,
                                                ).length
                                    "
                                ></v-divider>
                            </div>
                        </div>
                    </div>
                    <div v-if="tab == 'students'">
                        <student-list :students="getStudents()"></student-list>
                    </div>
                    <!-- <div v-if="tab == 'messages'">
                        <account-sms-messages
                            v-if="firebaseRef"
                            fromNumber="134737977553797755"
                            :accountID="account.accountID"
                            :name="account.name"
                            ref="accountSmsMessages"
                            :firebaseRef="firebaseRef"
                        >
                        </account-sms-messages>
                    </div> -->
                </v-tab-item>
            </v-tabs-items>
        </material-card>
        <edit-transaction
            ref="editTransaction"
            :student="editingStudent"
            :account="account"
            :ykAccount="ykAccount"
            :refresh="refresh"
            :country="country"
            :newStudentSelected="newStudentSelected"
            :newStudents="newStudents"
        ></edit-transaction>
        <v-dialog v-model="changeTransactionAmountDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pt-1 pl-0"
                    >Change Amount</v-card-title
                >
                <v-text-field
                    class="mb-2"
                    v-model="changeTransactionAmount.amount"
                    type="number"
                    label="Amount"
                >
                </v-text-field>
                <v-text-field
                    class="mb-2"
                    v-model="changeTransactionAmount.note"
                    label="Note"
                >
                </v-text-field>
                <v-card-actions class="mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="changeTransactionAmountDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="updateTransactionAmount"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="confirmDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are you sure?</v-card-title
                >
                <v-card-text class="mb-2 pt-0">{{
                    confirmationMessage
                }}</v-card-text>
                <v-text-field
                    class="mb-2 px-3"
                    v-if="isRefunding()"
                    type="number"
                    label="Refund Amount"
                    ref="refundAmount"
                    v-model="refundAmount"
                    :rules="refundAmountRules"
                    prefix="$"
                ></v-text-field>
                <v-text-field
                    class="px-3"
                    v-if="isRefunding()"
                    label="Refund Reason"
                    v-model="refundReason"
                ></v-text-field>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="confirmDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="processAction"
                    >
                        confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="editDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-3"
                    >Update Payment</v-card-title
                >
                <div class="pa-3">
                    <v-text-field
                        v-if="
                            editTransaction.type != 'CC' ||
                                isSchedulePayment(editTransaction)
                        "
                        class="mb-2"
                        type="number"
                        label="Amount"
                        ref="amount"
                        prefix="$"
                        :disabled="disableAmount(editTransaction)"
                        v-model="editTransaction.amount"
                        :rules="editTransaction.amountRules"
                    ></v-text-field>
                    <div
                        v-if="
                            editTransaction.type.includes('Check') &&
                                editTransaction.checkDetails &&
                                editTransaction.checkDetails.length
                        "
                        v-for="(check, index) in editTransaction.checkDetails"
                    >
                        <v-layout row>
                            <v-layout column>
                                <v-layout row>
                                    <v-text-field
                                        class="px-1 mr-1"
                                        label="Check Number"
                                        v-model="check.checkNumber"
                                    ></v-text-field>
                                    <v-text-field
                                        class="px-1 mr-1"
                                        label="Amount"
                                        placeholder="Amount"
                                        v-model="check.amount"
                                        @input="
                                            checkAmountChanged(editTransaction)
                                        "
                                        prefix="$"
                                        type="number"
                                    ></v-text-field>
                                </v-layout>
                            </v-layout>
                            <v-layout align-center>
                                <v-btn
                                    @click="addCheck(editTransaction)"
                                    flat
                                    icon
                                    color="success"
                                >
                                    <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                                <v-btn
                                    :disabled="index == 0"
                                    @click="removeCheck(index, editTransaction)"
                                    flat
                                    icon
                                    color="#f55a4e"
                                >
                                    <v-icon>mdi-minus-circle-outline</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-layout>
                    </div>
                    <v-select
                        v-if="editTransaction.type != 'CC'"
                        class="mb-4"
                        :items="paymentTypes.map((v) => v.value)"
                        label="Payment Type"
                        v-model="editTransaction.type"
                        hide-details
                        disabled
                    ></v-select>
                    <v-menu
                        v-if="
                            editTransaction.type != 'CC' ||
                                isSchedulePayment(editTransaction)
                        "
                        v-model="editTransaction.datePickerMenu"
                        :close-on-content-click="true"
                        full-width
                        max-width="290"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                :value="editTransaction.date"
                                label="Date"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="editTransaction.date"
                            @change="datePickerMenu = false"
                        ></v-date-picker>
                    </v-menu>
                    <!-- <v-text-field
                        v-if="editTransaction.type != 'CC'"
                        class="mb-2"
                        label="Check Number"
                        ref="checkNumber"
                        v-model="editTransaction.checkNumber"
                    ></v-text-field> -->
                    <v-text-field
                        class="mb-2"
                        label="Note"
                        v-model="editTransaction.note"
                    ></v-text-field>

                    <!-- <v-text-field
                        class="mb-2"
                        label="Receipt"
                        v-model="editTransaction.receipt"
                    ></v-text-field> -->
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="editDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="processUpdate"
                    >
                        update
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="emailReceiptDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Email Receipt</v-card-title>
                <v-text-field
                    class="px-3"
                    v-model="emailAddress"
                    :rules="emailRules"
                    ref="emailReceipt"
                ></v-text-field>
                <v-textarea
                    class="px-3 mb-3"
                    v-model="emailReceiptMessage"
                    hide-details
                    label="Message"
                    rows="6"
                    ref="emailReceiptMessage"
                ></v-textarea>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="emailReceiptDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="emailingReceipt"
                        color="success"
                        @click="emailReceipt"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="sendMessageDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Send Message</v-card-title>
                <v-text-field
                    :items="toNumbers"
                    label="To"
                    class="px-3"
                    v-model="messageTo"
                    :rules="[
                        (v) => !!v || 'A Valid Phone Number Is Required.',
                        (v) =>
                            !v ||
                            ([10, 11].includes(v.replace(/-/g, '').length) &&
                                /^\d+$/.test(v)) ||
                            'A Valid Phone Number Is Required.',
                    ]"
                ></v-text-field>
                <v-textarea
                    class="px-3 mb-3"
                    v-model="message"
                    hide-details
                    label="Message"
                    rows="4"
                    ref="message"
                ></v-textarea>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="sendMessageDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="sending"
                        color="success"
                        @click="sendMessage"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="sendEmailDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Send Email</v-card-title>
                <v-text-field
                    label="From"
                    class="px-3"
                    v-model="emailFrom"
                    ref="emailFrom"
                    :rules="emailRules"
                ></v-text-field>
                <v-text-field
                    label="To"
                    class="px-3"
                    v-model="emailTo"
                    ref="emailTo"
                    :rules="emailRules"
                ></v-text-field>
                <v-text-field
                    label="Subject"
                    class="px-3"
                    v-model="emailSubject"
                    ref="emailSubject"
                    :rules="required"
                ></v-text-field>
                <v-textarea
                    class="px-3 mb-3"
                    v-model="emailMessage"
                    hide-details
                    label="Message"
                    rows="6"
                    ref="message"
                ></v-textarea>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="sendEmailDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="sending"
                        color="success"
                        @click="sendEmailMessage"
                    >
                        Send
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="registerDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline">Register</v-card-title>
                <div v-for="student in studentsToRegister">
                    <v-layout
                        row
                        justify-space-between
                        class="px-3 mb-3"
                        style="min-width: %100;"
                    >
                        <div class="mr-3 pt-1">{{ student.hebName }}</div>
                        <v-checkbox
                            v-model="student.enrollment.isRegistered"
                            label="Registered"
                            class="mt-0"
                            color="success"
                            hide-details
                        ></v-checkbox></v-layout
                    ><v-divider></v-divider>
                </div>
                <v-card-actions class="mt-3">
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="registerDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveRegistration"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="makeCallDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0">Call</v-card-title>
                <v-text-field
                    class="mx-2"
                    label="From"
                    v-model="makeCallDetails.from"
                    ref="from"
                    :rules="phoneRules"
                ></v-text-field>
                <v-combobox
                    class="mx-2"
                    label="To"
                    ref="to"
                    v-model="makeCallDetails.to"
                    :items="accountPhones"
                    :rules="phoneRules"
                ></v-combobox>
                <v-text-field
                    class="mx-2"
                    label="Internal Number"
                    v-model="makeCallDetails.internalNumber"
                    ref="internalNumber"
                    :rules="phoneRules"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="makeCallDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="calling"
                        color="success"
                        @click="makeCall()"
                    >
                        Call
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="confirmCheckPaymentUpdateDialog"
            max-width="400"
        >
            <v-card class="pa-2">
                <v-card-title class="headline px-3"
                    >Confirm Change</v-card-title
                >
                <div class="font-weight-medium mb-3 px-3">
                    This check is already receipted with receipt #{{
                        editTransaction.receipt
                    }}, Changing the date to a later date will clear the receipt
                    number and will mark the check as unprocessed. Do you want
                    to continue ?
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="confirmCheckPaymentUpdateDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="savePaymentUpdate"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="addChargeDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-3 pb-2"
                    >New Charge</v-card-title
                >
                <div class="px-3 pt-2">
                    <!-- <v-select
                        label="Reg ID"
                        v-model="chargeRegID"
                        :items="years"
                        :rules="required"
                        ref="chargeRegID"
                    >
                    </v-select> -->
                    <v-select
                        label="Student"
                        v-model="chargeStudent"
                        :items="getAllStudentList().map((s) => s.hebName)"
                        :rules="required"
                        ref="chargeStudent"
                    >
                    </v-select>
                    <v-select
                        label="Charge Description"
                        v-model="chargeDescription"
                        :items="items.map((i) => i.description)"
                        @change="chargeNameChanged"
                        :rules="required"
                        ref="chargeDescription"
                        class="mb-2"
                    >
                    </v-select>
                    <v-layout row>
                        <v-text-field
                            class="pt-0 mr-3"
                            label="Quantity"
                            v-model="chargeQuantity"
                            type="number"
                            ref="chargeQuantity"
                            :rules="required"
                        ></v-text-field>
                        <v-text-field
                            class="pt-0"
                            label="Price"
                            v-model="chargePrice"
                            prefix="$"
                            type="number"
                            ref="chargePrice"
                            :rules="required"
                        ></v-text-field>
                        <div class="pt-3 ml-3 font-weight-medium">
                            ${{ (chargeQuantity * chargePrice).toFixed(2) }}
                        </div>
                    </v-layout>
                    <v-text-field
                        class="pt-0"
                        label="Note"
                        v-model="chargeNote"
                        ref="chargeNote"
                    ></v-text-field>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="default" @click="addChargeDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveCharges"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import editTransaction from "./EditTransaction.vue";
//import addStudent from "./AddStudent.vue";
import moment from "moment";
import { loadOptions } from "../../utils/smLookup.js";
import {
    getDomain,
    except,
    toTitleCase,
    toISOLocal,
    sum,
    truncate,
} from "../../utils/helpers.js";
import * as firebase from "firebase/app";
import "firebase/database";
import accountSmsMessages from "../Account/AccountSmsMessages.vue";
import axios from "axios";
import studentList from "../Account/StudentList.vue";
import transactionPaymentDetails from "../Payment/TransactionPaymentDetails.vue";

export default {
    props: {
        transactionsLoading: Boolean,
        transactions: Array,
        enrolledStudents: Array,
        students: Array,
        documents: Array,
        account: Object,
        ykAccount: Object,
        refresh: Function,
        country: String,
        regID: String,
        currentRegID: String,
        openDialogForStudent: Object,
        openPaymentModal: Function,
        printStatement: Function,
        openEmailStatementDialog: Function,
        openNewCreditCardModal: Function,
        openUploadDocumentDialog: Function,
        openCopyDocumentDialog: Function,
        hasCopy: Function,
        downloading: Boolean,
        transactionPaymentDetails,
    },
    components: {
        "edit-transaction": editTransaction,
        accountSmsMessages,
        studentList,
        transactionPaymentDetails,
        //"add-student": addStudent,
    },
    data() {
        return {
            activeTab: "all",
            editingStudent: null,

            confirmationMessage: "",
            confirmDialog: false,
            confirmAction: null,
            refundReason: "",
            refundAmount: 0,
            refundTransactionAmount: {},
            paymentTypes: [],

            editDialog: false,
            confirmCheckPaymentUpdateDialog: false,
            newStudents: [],
            gradesSetup: [],
            charges: [],
            items: [],

            editTransaction: {
                transactionID: "",
                amount: "",
                type: "",
                note: "",
                receipt: "",
                date: "",
                checkNumber: "",
                datePickerMenu: false,
                amountRules: [(v) => !!v || "Amount Is Required"],
            },

            firebaseRef: "",
            //pendingMessagesCount: 0,

            newStudentDialog: false,

            processing: false,

            message: "",
            messageTo: "",
            toNumbers: [],
            sendMessageDialog: false,
            sendEmailDialog: false,
            emailMessage: "",
            emailTo: "",
            emailFrom: "",
            emailSubject: "",
            sending: false,
            downloadingReceipt: false,

            emailAddress: "",
            receiptToEmail: {},
            emailReceiptDialog: false,
            emailReceiptMessage: "",
            emailingReceipt: false,

            registerDialog: false,
            studentsToRegister: [],

            changeTransactionAmount: {
                amount: 0,
                id: "",
                original: "",
            },
            changeTransactionAmountDialog: false,

            calling: false,

            makeCallCallback: "",
            makeCallDialog: false,
            makeCallDetails: {
                from: "",
                callerID: "",
                to: "",
                internalNumber: "",
                accountId: "",
                username: "",
            },

            addChargeDialog: false,

            chargeDescription: "",
            chargeQuantity: "",
            chargeNote: "",
            chargePrice: "",
            chargeStudent: "",

            accountPhones: [],

            emailRules: [
                (value) => !!value || "Required.",
                (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            ],

            phoneRules: [
                (value) => !!value || "Required.",
                (v) => {
                    return (
                        !v ||
                        ([10, 11].includes(v.trim().replace(/-/g, "").length) &&
                            /^\d+$/.test(v.trim().replace(/-/g, ""))) ||
                        "A Valid Phone Number Is Required."
                    );
                },
            ],

            required: [(value) => !!value || "Required."],

            refundAmountRules: [
                (value) => {
                    if (value) {
                        return (
                            value <= this.refundTransactionAmount ||
                            "Can't be more than Payment Amount"
                        );
                    }

                    return !!value || "Refund Amount Is Required";
                },
            ],
        };
    },
    beforeDestroy() {
        //this.firebaseRef.off();
    },
    async created() {
        await this.loadPaymentTypes();
        await this.loadGradesSetup();
        await this.loadCharges();
        await this.loadYkItems();

        this.emailFrom = this.$store.state.authentication.user;
    },
    watch: {
        openDialogForStudent(newValue, oldValue) {
            // if (this.openDialogForStudent && !this.editingStudent) {
            //     this.openTransactionDialog(this.openDialogForStudent);
            // }
        },
        account(newValue) {
            if (newValue) {
                this.messageTo = this.account.cellPhone
                    ? this.account.cellPhone.replaceAll("-", "")
                    : "";
                this.emailTo = this.account.emailAddress
                    ? this.account.emailAddress.trim()
                    : this.account.emailAddress;

                this.loadAccountPhones(newValue.accountID);
            }
        },
    },
    computed: {
        formatedDate() {
            return this.editTransaction.date
                ? moment(new Date(this.editTransaction.date)).format("L")
                : "";
        },
    },
    methods: {
        async loadAccountPhones(accountID) {
            const accountPhones = await this.$http.get(
                "api/broadcast/getAccountPhones?accountID=" +
                    accountID +
                    "&all=true",
            );

            this.accountPhones = accountPhones.map((p) => p.phoneNum);
        },
        async loadPaymentTypes() {
            this.paymentTypes = await this.$http.get("api/yk/getPaymentTypes");
        },
        async loadCharges() {
            const charges = await this.$http.get("api/yk/getcharges");

            this.charges = charges;
        },
        async loadYkItems() {
            const response = await this.$http.get(
                "api/lapidus/getBillingSetup?categoryCode=YKC",
            );

            this.items = response.map((item) => {
                item.quantity = "";
                item.price = item.unitPrice;

                return item;
            });
        },
        getStatementActions() {
            return [
                {
                    text: "Print",
                    action: this.printStatement,
                    processing: this.downloading,
                },
                { text: "Email", action: this.openEmailStatementDialog },
            ];
        },
        getMessageActions() {
            return [
                {
                    text: "Text",
                    action: this.openSendMessageDialog,
                    processing: this.downloading,
                },
                { text: "Email", action: this.openEmailMessageDialog },
                { text: "Call", action: this.openMakeCallDialog },
            ];
        },
        getTabList() {
            switch (this.activeTab) {
                case "bills":
                    return this.transactions.filter((t) => t.txnType == "D");
                case "payments":
                    return this.transactions.filter((t) => t.txnType == "C");
                default:
                    return this.transactions;
            }
        },
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
                authDomain: "utaw.firebaseapp.com",
                databaseURL: "https://utaw.firebaseio.com",
                projectId: "project-683582246459980907",
                storageBucket: "project-683582246459980907.appspot.com",
                messagingSenderId: "193425158146",
                appId: "1:193425158146:web:f1ae134a803fb75832371b",
            };

            // Initialize Firebase
            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("incoming-messages");

            const query = ref
                .orderByChild("AccountID")
                .equalTo(this.account.accountID)
                .limitToLast(1);

            this.firebaseRef = query;

            this.firebaseRef.on(
                "value",
                (snapshot) => {
                    // if (snapshot.val()) {
                    //     this.pendingMessagesCount = snapshot.val()[
                    //         Object.keys(snapshot.val())
                    //     ].PendingCount;
                    // }
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
        getStudents() {
            return this.transactions
                .filter(
                    (t) =>
                        t.txnType == "D" &&
                        t.description.startsWith("Yeshiva Ketana Camp"),
                )
                .map((t) => t.student);
        },
        getAllStudentList() {
            return this.students;
        },
        getTransactionStatus(transaction) {
            if (transaction.txnType == "D") return "BILL";

            if (this.isPastDue(transaction)) return "SCHEDULED PAST DUE";

            return transaction.paymentStatus;
        },
        isPastDue(transaction) {
            const today = new Date();

            if (
                this.getPaymentType(transaction) == "Cash/Check" ||
                (transaction.schedules &&
                    transaction.schedules.some((s) => s.status == "Scheduled"))
            ) {
                return (
                    new Date(transaction.date) < today &&
                    (transaction.paymentStatus == "SCHEDULED" ||
                        !transaction.receiptNumber)
                );
            }
        },
        getStatusIcon(transaction) {
            if (transaction.txnType == "D") return "mdi-currency-usd";

            if (this.isPastDue(transaction)) return "mdi-alert-octagon";

            switch (transaction.paymentStatus.toUpperCase()) {
                case "PROCESSED":
                    return "mdi-check-circle";
                case "DECLINED":
                    return "mdi-alert";
                case "ERROR":
                    return "mdi-alert-circle";
                case "SCHEDULED":
                    return "mdi-clock";
                default:
                    return "";
            }
        },
        getStatusIconColor(transaction) {
            if (transaction.txnType == "D") return "success";

            if (this.isPastDue(transaction)) return "#f35123";

            switch (transaction.paymentStatus.toUpperCase()) {
                case "PROCESSED":
                    return "success";
                case "DECLINED":
                case "ERROR":
                    return "#f35123";
                case "SCHEDULED":
                    return "#fdb400";
                default:
                    return "#aeb8bf";
            }
        },
        isScheduled(transaction) {
            return (
                new Date() < new Date(transaction.date) ||
                (transaction.schedule &&
                    transaction.schedule.status == "Scheduled")
            );
        },
        getTransactionTitle(transaction) {
            if (transaction.txnType == "C") {
                if (
                    transaction.paymentTypeID &&
                    [1, 6, 7, 8, 9].includes(transaction.paymentTypeID)
                )
                    return "Discount - " + moment(transaction.date).format("L");
                if (
                    transaction.paymentTypeID &&
                    [5, 10].includes(transaction.paymentTypeID)
                )
                    return "Credit - " + moment(transaction.date).format("L");

                return this.isScheduled(transaction)
                    ? "Scheduled Payment - " +
                          moment(transaction.date).format("L")
                    : "Payment - " + moment(transaction.date).format("L");
            }

            const student = transaction.student;

            if (transaction.description == "Previous Balance")
                return transaction.description;

            return (
                transaction.description +
                " - " +
                moment(transaction.date).format("L")
            );

            if (!student.name)
                return (
                    `Missing Name (${
                        transaction.student.enrollment.class
                            ? transaction.student.enrollment.class
                            : ""
                    }) - ` + transaction.description
                );

            return (
                `${student.name} - ${student.hebName} (${student.class})` +
                " - " +
                transaction.description
            );
        },
        getStudentInfo(transaction) {
            if (transaction.description == "Previous Balance") return "";

            const student = transaction.student;

            if (!student.name) {
                return (
                    `Missing Name (${
                        transaction.student.enrollment.class
                            ? transaction.student.enrollment.class
                            : ""
                    }) - ` + transaction.description
                );
            }

            return `${student.name} - ${student.hebName} (${student.class})`;
        },
        getPaymentDescription(transaction) {
            return (
                this.getPaymentType(transaction) +
                (transaction.receiptNumber
                    ? " | Receipt #" + transaction.receiptNumber
                    : "")
            );
        },
        getTransactionAmount(transaction) {
            if (
                ["Refund", "Void"].includes(this.getPaymentType(transaction)) ||
                transaction.amount < 0
            )
                return "-$" + Math.abs(transaction.amount);

            return "$" + transaction.amount;
        },
        getPaymentType(transaction) {
            if (transaction.txnType == "D") return;

            if (transaction.description.startsWith("CK")) return "ACH";

            if (transaction.description.startsWith("Country Voucher"))
                return "Country Voucher";

            return !transaction.description.includes(" ")
                ? transaction.description
                : transaction.description.substr(
                      0,
                      transaction.description.indexOf(" "),
                  );
        },
        hasSchedule(schedules) {
            return schedules.length;
        },
        getScheduleDate(schedules) {
            if (!this.hasSchedule(schedules)) return;

            return schedules[0].scheduleDate;
        },
        getEnabledStatus(schedules) {
            if (!this.hasSchedule(schedules)) return;

            return schedules[0].isEnabled ? "Yes" : "No";
        },
        getPaymentsTitle(payments) {
            return payments.length == 1
                ? "Payment"
                : "Payments (" + payments.length + ")";
        },
        getPaymentStatusIcon(payment) {
            switch (payment.statusValue.toUpperCase()) {
                case "PROCESSED":
                    return "mdi-check-circle";
                case "DECLINED":
                    return "mdi-alert";
                case "ERROR":
                    return "mdi-alert-circle";
                case "SCHEDULED":
                    return "mdi-clock";
                default:
                    return "";
            }
        },
        getPaymentStatusIconColor(payment) {
            switch (payment.statusValue.toUpperCase()) {
                case "PROCESSED":
                    return "success";
                case "DECLINED":
                case "ERROR":
                    return "#f35123";
                case "SCHEDULED":
                    return "#fdb400";
                default:
                    return "#aeb8bf";
            }
        },
        expandPayment(payment, transaction) {
            if (!payment) return;

            payment.expanded = !payment.expanded;

            console.log(transaction.payments);

            transaction.payments
                .filter((p) => p.paymentID != payment.paymentID)
                .forEach((p) => {
                    p.expanded = false;
                });

            this.$forceUpdate();
        },
        getSchedulesTitle(schedules) {
            return schedules.length == 1
                ? "Schedule"
                : "Schedules (" + schedules.length + ")";
        },
        getScheduleStatusIcon(schedule) {
            if (schedule.status.toUpperCase().startsWith("ERROR"))
                return "mdi-alert-circle";

            switch (schedule.status.toUpperCase()) {
                case "PROCESSED":
                case "APPROVED":
                    return "mdi-check-circle";
                case "DECLINED":
                    return "mdi-alert";
                case "ERROR":
                    return "mdi-alert-circle";
                case "SCHEDULED":
                    return "mdi-clock";
                default:
                    return "";
            }
        },
        getScheduleStatusIconColor(schedule) {
            if (schedule.status.toUpperCase().startsWith("ERROR"))
                return "#f35123";

            switch (schedule.status.toUpperCase()) {
                case "PROCESSED":
                case "APPROVED":
                    return "success";
                case "DECLINED":
                case "ERROR":
                    return "#f35123";
                case "SCHEDULED":
                    return "#fdb400";
                default:
                    return "#aeb8bf";
            }
        },
        expandSchedule(schedule, transaction) {
            if (!schedule) return;

            schedule.expanded = !schedule.expanded;

            transaction.schedules
                .filter((p) => p.scheduleDetailID != schedule.scheduleDetailID)
                .forEach((p) => {
                    p.expanded = false;
                });

            console.log(schedule);
            console.log(transaction.schedules);

            this.$forceUpdate();
        },
        truncateText(text) {
            return truncate(text, 50);
        },
        getRegisteredWeeks(transaction) {
            const weeks = Object.keys(transaction.student.enrollment)
                .map((key) => {
                    if (
                        !key.startsWith("week") ||
                        !transaction.student.enrollment[key]
                    )
                        return;

                    return key.substring(4);
                })
                .filter(Boolean);

            return weeks.join(", ");
        },
        async addStudent() {
            this.newStudents = await this.loadStudents();

            this.openTransactionDialog({
                enrollment: {},
            });
        },
        async loadStudents() {
            const students = await this.$http.get(
                `api/lapidusDayCamp/getStudents?linkId=${
                    this.account.accountLinkID
                }&pin=${this.account.pinNum}`,
            );

            const enrolledStudents = await this.$http.get(
                "api/yk/GetEnrolledStudents?accountID=" +
                    this.account.accountID +
                    "&regID=" +
                    this.regID,
            );

            return students.filter(
                (s) =>
                    !enrolledStudents
                        .map((student) => student.studentID)
                        .includes(s.studentID) && this.hasDayCamp(s),
            );
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get("api/yk/getGradesSetup");
        },
        hasDayCamp(student) {
            return this.gradesSetup.find((g) => g.grade == student.class)
                .isYKCAvail;
        },
        openEditAmountDialog(transaction) {
            this.changeTransactionAmount = {
                amount: transaction.amount,
                note: transaction.note,
                original: transaction.amount,
                id: transaction.txnID,
            };

            this.changeTransactionAmountDialog = true;
        },
        allowDeleting() {
            return (
                this.$store.state.authentication.user == "jwercberger@utaw.org"
            );
        },
        async deleteCharge(transaction) {
            await this.$http.post(
                "api/yk/deleteCharge?id=" + transaction.txnID,
            );

            this.$notify({
                text: "Charge Delete",
                group: "notification",
                type: "success",
            });

            this.refresh();
        },
        rollbackChangeTransactionAmount(transaction) {
            this.changeTransactionAmountDialog = false;
        },
        async updateTransactionAmount() {
            try {
                this.processing = true;

                await this.$http.post("api/yk/updateTransactionAmount", {
                    txnID: this.changeTransactionAmount.id,
                    amount: this.changeTransactionAmount.amount,
                    note: this.changeTransactionAmount.note,
                    user: this.$store.state.authentication.user,
                });
                this.processing = false;

                this.changeTransactionAmountDialog = false;

                this.refresh();
            } catch (e) {
                this.processing = false;
            }
        },
        openRegisterDialog() {
            this.studentsToRegister = this.getStudents();

            this.registerDialog = true;
        },
        async saveRegistration() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/yk/register",
                    this.studentsToRegister.map((s) => ({
                        studentID: s.studentID,
                        isRegistered: s.enrollment.isRegistered,
                        regID: this.regID,
                    })),
                );

                this.processing = false;
                this.registerDialog = false;

                this.$notify({
                    text: "Registration Saved",
                    group: "notification",
                    type: "success",
                });

                this.refresh();
            } catch (e) {
                this.processing = false;
            }
        },
        newStudentSelected(student) {
            if (!student) {
                this.editingStudent = {
                    enrollment: {},
                };

                return;
            }

            this.editingStudent = {
                isEnrolled: false,
                enrollment: {
                    regType: "NONE",
                    week1: false,
                    week2: false,
                    week3: false,
                    week4: false,
                    week5: false,
                    week6: false,
                    week7: false,
                    week8: false,
                    week9: false,
                },
                name: student.engName,
                studentID: student.studentID,
                hebName: student.hebName,
                class: student.class,
                chosenClass: "",
                charges: this.charges.map((charge) => {
                    charge.paymentAmount = charge.amount;

                    return charge;
                }),
                total: 0,
            };
        },
        openTransactionDialog(student) {
            if (
                student.originalDuration == "NONE" &&
                student.enrollment.regType == "NONE"
            ) {
                student.charges = this.charges.map((charge) => {
                    charge.paymentAmount = charge.amount;

                    return charge;
                });

                student.total = sum(
                    student.charges.map((c) => +c.paymentAmount),
                );
            }

            this.editingStudent = student;

            this.$refs.editTransaction.openDialog(
                JSON.parse(JSON.stringify(student)),
            );
        },
        async processAction() {
            if (this.isRefunding() && !this.$refs.refundAmount.validate(true))
                return;

            this.processing = true;

            try {
                await this.confirmAction();
            } catch (e) {
                if (this.isRefunding()) {
                    this.$notify({
                        text: e,
                        group: "notification",
                        type: "error",
                    });
                }

                this.processing = false;

                return;
            }

            if (this.isRefunding()) {
                this.$notify({
                    text: "Payment Refunded",
                    group: "notification",
                    type: "success",
                });
            }

            this.processing = false;

            this.confirmDialog = false;
            this.refundTransactionAmount = {};

            this.refresh();
        },
        updatePayment(transaction) {
            var lastIndex = transaction.description.lastIndexOf("#");
            const receipt = transaction.description.substring(lastIndex + 1);

            this.editTransaction.transactionID = transaction.txnID;
            this.editTransaction.receipt = transaction.receiptNumber;
            this.editTransaction.date = new Date(moment(transaction.date))
                .toISOString()
                .substr(0, 10);
            this.editTransaction.schedule = transaction.schedule;
            this.editTransaction.payment = transaction.payment;
            this.editTransaction.amount = transaction.amount;
            this.editTransaction.type = this.getPaymentType(transaction);
            this.editTransaction.note = transaction.note;

            this.editTransaction.scheduleDetailID =
                transaction.scheduleDetailID;
            this.editTransaction.paymentLogID = transaction.paymentLogID;

            this.editTransaction.checkDetails = JSON.parse(
                JSON.stringify(transaction.checkDetails),
            );
            this.editTransaction.checkNumber = this.getCheckNumber(transaction);

            this.editDialog = true;
        },
        isDeclined(transaction) {
            if (transaction.txnType != "C") return;

            return (
                transaction.paymentStatus &&
                transaction.paymentStatus.toUpperCase() == "DECLINED"
            );

            // return (
            //     (transaction.payment &&
            //         transaction.payment.status == "DECLINED") ||
            //     (transaction.schedule &&
            //         transaction.schedule.status == "Declined")
            // );
        },
        isError(transaction) {
            if (transaction.txnType != "C") return;

            return (
                transaction.paymentStatus &&
                transaction.paymentStatus.toUpperCase() == "ERROR"
            );

            // return (
            //     (transaction.payment &&
            //         transaction.payment.status == "ERROR") ||
            //     (transaction.schedule &&
            //         transaction.schedule.status.startsWith("Error"))
            // );
        },
        isSchedulePayment(transaction) {
            if (
                transaction.schedule &&
                transaction.schedule.status == "Approved"
            )
                return false;

            return transaction.scheduleDetailID && !transaction.paymentLogID;
        },
        getCheckNumber(transaction) {
            if (this.getPaymentType(transaction) == "CC") return "";

            var index = transaction.description.indexOf("#");
            const value = transaction.description.substring(index + 1);

            return value.substring(0, value.indexOf(" "));
        },
        getCheckDetails(transaction) {
            if (
                this.getPaymentType(transaction) != "Cash/Check" &&
                (!transaction.checkDetails || !transaction.checkDetails.length)
            )
                return [];

            if (
                this.getPaymentType(transaction) == "Cash/Check" &&
                (!transaction.checkDetails || !transaction.checkDetails.length)
            ) {
                return [
                    {
                        checkNumber: this.getCheckNumber(transaction),
                        date: transaction.date,
                        amount: transaction.amount,
                    },
                ];
            }

            return transaction.checkDetails;
        },
        getPaymentTypeID(transaction) {
            if (!this.paymentTypes.length || !transaction.type) return {};

            const type =
                transaction.type == "CC" ? "Credit Card" : transaction.type;

            const paymentType = this.paymentTypes.find((p) => p.value == type);

            return paymentType ? paymentType.id : null;
        },
        needsToConfrimCheckUpdate(transaction) {
            const moveToLaterDate = new Date(transaction.date) > new Date();

            const originalTransaction = this.transactions.find(
                (t) => t.txnID == transaction.transactionID,
            );

            return (
                this.editTransaction.type == "Cash/Check" &&
                this.getTransactionStatus(originalTransaction) == "PROCESSED" &&
                moveToLaterDate
            );
        },
        openConfirmCheckPaymentUpdate() {
            this.confirmCheckPaymentUpdateDialog = true;
        },
        async processUpdate() {
            if (
                this.editTransaction.type != "CC" &&
                !this.$refs.amount.validate(true)
            )
                return;

            if (this.needsToConfrimCheckUpdate(this.editTransaction)) {
                return this.openConfirmCheckPaymentUpdate();
            }

            await this.savePaymentUpdate();
        },
        async savePaymentUpdate() {
            this.processing = true;

            const {
                transactionID,
                receipt,
                date,
                amount,
                type,
                note,
                checkNumber,
                checkDetails,
                scheduleDetailID,
            } = this.editTransaction;

            const data = {
                transactionID,
                scheduleDetailID,
                receipt,
                date: moment(date).format("YYYY-MM-DD HH:mm:ss"),
                amount,
                note,
                checkNumber: type == "Check" ? checkNumber : "",
                paymentType: type,
                paymentTypeID: this.getPaymentTypeID(this.editTransaction),
                checkDetails: type.includes("Check") ? checkDetails : [],
                user: this.$store.state.authentication.user,
            };

            try {
                await this.$http.post("api/yk/UpdateTransaction", data);
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;

            this.editDialog = false;
            this.confirmCheckPaymentUpdateDialog = false;
            this.refresh();
        },
        allowRefund(transaction) {
            return (
                this.getPaymentType(transaction) == "CC" &&
                moment(new Date(transaction.date)).isBefore(new Date())
            );
        },
        isRefunding() {
            return this.confirmationMessage.includes("Refund/Void");
        },
        voidPayment(transaction) {
            this.confirmationMessage = "Refund/Void Payment";

            this.refundAmount = transaction.amount;
            this.refundTransactionAmount = transaction.amount;

            this.confirmAction = () => {
                return this.$http.post(`api/yk/voidPayment`, {
                    accountID: this.account.accountID,
                    user: this.$store.state.authentication.user,
                    paymentID: this.getSuccessfulPayment(transaction.payments)
                        .paymentID,
                    amount: this.refundAmount,
                    reason: this.refundReason,
                    regID: this.regID,
                    source: "YK",
                });
            };

            this.confirmDialog = true;
        },
        deletePayment(transaction) {
            this.confirmationMessage =
                "This will delete the payment of $" + transaction.amount;

            this.confirmAction = () => {
                return this.$http.post(
                    "api/yk/DeleteTransaction?transactionID=" +
                        transaction.txnID +
                        "&user=" +
                        this.$store.state.authentication.user,
                );
            };

            this.confirmDialog = true;
        },
        getSuccessfulPayment(payments) {
            return payments.find((p) => p.status == "PROCESSED");
        },
        isLaterDate(date) {
            return moment(new Date(date)).isAfter(new Date());
        },
        cancelScheduledPayment(transaction) {
            if (!transaction.scheduleDetailID) {
                this.$notify({
                    group: "notification",
                    text: "Can't cancel payment without Schedule ID.",
                    type: "error",
                });

                return;
            }

            this.confirmationMessage =
                "This will cancel the payment of $" +
                transaction.amount +
                " scheduled for " +
                moment(transaction.date).format("L");

            this.confirmAction = () => {
                return this.$http.post(
                    "api/yk/DeleteTransaction?transactionID=" +
                        transaction.txnID +
                        "&user=" +
                        this.$store.state.authentication.user,
                );
            };

            this.confirmDialog = true;
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        onNewStudentCreated(student) {
            const existing = this.transactions
                .filter((t) => t.txnType == "D")
                .find((s) => (s.student.studentID = student.studentID));

            existing.engName = student.engName;
            existing.name = student.engName;
            existing.hebName = student.hebName;
            existing.dob = student.dob;
            existing.class = student.class;

            this.newStudentDialog = false;

            this.refresh();
        },
        editStudentInfo(student) {
            this.$refs.newStudent.prefill(student);

            this.newStudentDialog = true;
        },
        async openDocument(document) {
            const url = await this.$http.get(
                "/api/yk/GetImmunizationsDocument?filePath=" + document.fileURL,
            );

            window.open(url);
        },
        getDocumentsForStudent(student) {
            return this.documents.filter(
                (doc) =>
                    doc.studentID == student.studentID.trim() &&
                    (doc.category.toUpperCase() == "HEALTH FORM" ||
                        doc.category.toUpperCase() == "INSURANCE CARD"),
            );
        },
        getDocuments(student, requirment) {
            let category = "";

            switch (requirment.description) {
                case "Health Form":
                    category = "HEALTH FORM";
                    break;
                case "Lunch Document":
                    category = "LUNCH";
                    break;
                case "Hiscyvis Letter":
                    category = "HISCYVIS";
                    break;
                case "Insurance / Medicaid Card":
                    category = "INSURANCE CARD";
                    break;
            }

            return this.documents.filter(
                (doc) =>
                    doc.studentID == student.studentID.trim() &&
                    doc.category.toUpperCase() == category,
            );
        },
        getProperties(transaction) {
            return Object.keys(
                except(
                    transaction,
                    "payment",
                    "payments",
                    "schedule",
                    "schedules",
                    "student",
                    "date",
                    "userUpdated",
                    "lastUpdated",
                    "dateCreated",
                    "checkDetails",
                ),
            )
                .map((key) => {
                    return {
                        name: toTitleCase(key),
                        value: transaction[key],
                    };
                })
                .filter((p) => p.value);
        },
        getPaymentProperties(payment) {
            if (!payment) return;

            return Object.keys(
                except(
                    payment,
                    "accountID",
                    "name",
                    "date",
                    "amount",
                    "paymentType",
                    "statusIcon",
                    "status",
                    "source",
                    "scheduleDetailID",
                    "scheduleID",
                    "paymentMethodID",
                    "expanded",
                ),
            )
                .map((key) => {
                    return {
                        name: toTitleCase(key),
                        value: payment[key],
                    };
                })
                .filter((p) => p.value);
        },
        getScheduleProperties(schedule) {
            if (!schedule) return;

            return Object.keys(
                except(
                    schedule,
                    "accountID",
                    "name",
                    "date",
                    "scheduleDate",
                    "dateCreated",
                    "amount",
                    "paymentType",
                    "source",
                    "statusIcon",
                    "scheduleDetailID",
                    "scheduleID",
                    "paymentMethodID",
                    "userUpdated",
                    "lastUpdated",
                    "expanded",
                ),
            )
                .map((key) => {
                    return {
                        name: toTitleCase(key),
                        value: schedule[key],
                    };
                })
                .filter((p) => p.name == "IsEnabled" || p.value);
        },
        deleteDocument(document) {
            this.confirmationMessage = "This will delete the document";

            this.confirmAction = () => {
                return this.$http.post(
                    "api/yk/DeleteFile?documentID=" +
                        document.documentID +
                        "&documentType=" +
                        document.category,
                );
            };

            this.confirmDialog = true;
        },
        allowUpload(status) {
            return ["MISSING", "REJECTED"].includes(status);
        },
        download(requirment, student) {
            let url = "";

            switch (requirment.description) {
                case "Health Form":
                    url =
                        "https://uta-admin-portal.azurewebsites.net/api/yk/downloadForm?accountID=" +
                        this.ykAccount.accountID.trim() +
                        "&studentID=" +
                        student.studentID.trim();
                    break;
                case "Lunch Document":
                    url =
                        "https://utaw.blob.core.windows.net/publications/YkLunchDoc.pdf";
                    break;
                case "Hiscyvis Letter":
                    url =
                        "https://utaw.blob.core.windows.net/publications/ykletter.pdf";
                    break;
            }

            window.open(url);
        },
        getReceiptNumber(transaction) {
            const lastIndex = transaction.description.lastIndexOf("#");
            const lastSegment = transaction.description.substring(
                lastIndex + 1,
            );

            return lastSegment.trim() == this.getPaymentType(transaction)
                ? ""
                : lastSegment;
        },
        createReceipt(transaction) {
            const receipt = transaction.receiptNumber;

            let html = `<!DOCTYPE html style="background-color: #f3eedd !important">
                <html>
                <head>
                <style>
                table {
                  font-family: arial, sans-serif;
                  border-collapse: collapse;
                }

                td, th {
                  padding: 6px;
                }
                .no-border td, th {
                    border: none;
                }
                .account-info {
                    font-family: arial, sans-serif;
                    text-align: left;
                    font-weight: 200;
                    margin-bottom: 30px;
                    line-height: 1.5;
                    font-size: 25px !important;
                }
                .text-table td, table {
                    border: none;
                    padding: 0px;
                    background-color: #fff;
                    line-height: 1.5;
                    font-size: 25px !important;
                }
                .regular-text {
                    margin-bottom: 5px;
                    margin-top: 0px;
                    font-size: 36px !important;
                }
                .title {
                    font-size: 30px !important;
                }
                </style>
                <div style="margin-right: 64px !important">
                <img src="https://utaw.blob.core.windows.net/images/ykletterhead2.jpg">
                </div>
                </head>
                <body style="padding: 32px; margin-right: 32px; margin-left: 32px">

                <p style="margin-top: 32px; margin-bottom: 20px;">&nbsp;</p>

                <p style="text-align: center;" class="account-info title"><strong>RECEIPT ${
                    receipt ? "#" + receipt : ""
                }</strong></p>

                <p style="text-align: right;" class="account-info"><strong>${moment(
                    transaction.date,
                ).format("L")}</strong></p>

                <div class="account-info">
                <p class="regular-text"><strong>${
                    this.account.name
                }</strong></p>
                <p class="regular-text"><strong>Address: </strong>${
                    this.account.address1
                }</p>
                <p class="regular-text"><strong>Phone: </strong>${
                    this.account.homePhone
                }</p>`;

            if (this.ykAccount.emailAddress) {
                html += `<p class="regular-text"><strong>Email: </strong>${
                    this.ykAccount.emailAddress
                }</p>`;
            }

            html += `</div>`;

            html += `<table class="no-border account-info" align="right" style="width: 35%; padding: 16px !important;" border="1">
                    <tbody>
                    <tr class="regular-text">

                    <td>Payment Type</td>
                    <td style="text-align: right;"><strong>${this.getPaymentType(
                        transaction,
                    )}</strong></td>
                    </tr>
                    <tr class="regular-text">

                    <td>Payment Amount</td>
                    <td style="text-align: right;"><strong>$${
                        transaction.amount
                    }</strong></td>
                    </tr>
                    <hr>
                    `;

            html += `
                <tr>
                <td><p class="regular-text">Previous Balance:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.previousBalance
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Billed:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.debit
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Paid:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.paid
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Credit:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.credit
                    }</strong></p></td>
                </tr>
                <td><p class="regular-text">Total Balance:</p></td>
                    <td style="text-align: right;"><p class="regular-text"><strong>$${
                        this.ykAccount.balance
                    }</strong></p></td>
                </tr>
                </table>`;

            html += `</body>
                </html>`;

            return html;
        },
        printReceipt(transaction) {
            const html = this.createReceipt(transaction);

            const url = getDomain() + "/api/yk/downloadLetter";

            this.downloadingReceipt = true;

            axios({
                url: url,
                data: {
                    html,
                },
                method: "POST",
                responseType: "blob",
            })
                .then((response) => {
                    this.downloadingReceipt = false;

                    const url = window.URL.createObjectURL(
                        new Blob([response.data]),
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "YK_Receipt.pdf"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(() => {
                    this.downloadingReceipt = false;
                });
        },
        openEmailReceiptDialog(transaction) {
            this.receiptToEmail = transaction;

            this.emailAddress = this.account.emailAddress
                ? this.account.emailAddress.trim()
                : this.account.emailAddress;

            this.emailReceiptMessage =
                "Attached is the Receipt for your payment.\n\n\n<br>" +
                "\n<br>" +
                "\n<br>" +
                `<a href="camp.yksw.org">Access your Account Portal</a>` +
                "\n<br>" +
                "User Name: " +
                this.ykAccount.jlWebUsername +
                "\n<br>" +
                "Password:  " +
                this.ykAccount.jlWebPassword;

            this.emailReceiptDialog = true;
        },
        async emailReceipt() {
            if (!this.$refs.emailReceipt.validate(true)) return;

            this.emailingReceipt = true;

            try {
                await this.$http.post("api/yk/emailLetter", {
                    emailAddress: this.emailAddress,
                    html: this.createReceipt(this.receiptToEmail),
                    subject: "Yeshiva Ketana Camp Receipt",
                    message: this.emailReceiptMessage,
                    isHtml: true,
                    accountID: this.account.accountID,
                });

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                this.emailingReceipt = false;
                this.emailReceiptDialog = false;
            } catch (e) {
            } finally {
                this.emailingReceipt = false;
            }
        },
        openMakeCallDialog() {
            this.makeCallDetails.to = "";

            this.makeCallDetails.from = "17189639260";

            const savedInternalNumber = localStorage.getItem(
                "user-internal-number",
            );

            this.makeCallDetails.internalNumber = savedInternalNumber;

            if (!savedInternalNumber) {
                this.makeCallDetails.internalNumber = this.$store.getters[
                    "authentication/getUtaPhone"
                ];
            }

            this.makeCallDialog = true;
        },
        openAddChargeDialog() {
            if (this.getStudents().length == 1) {
                this.chargeStudent = this.getStudents()[0].hebName;
            }

            this.chargeQuantity = 1;

            this.addChargeDialog = true;
        },
        chargeNameChanged(value) {
            const item = this.items.find((i) => i.description == value);

            this.chargePrice = item.unitPrice;
        },
        async saveCharges() {
            if (
                !this.$refs.chargeDescription.validate(true) ||
                !this.$refs.chargeStudent.validate(true) ||
                !this.$refs.chargeQuantity.validate(true) ||
                !this.$refs.chargePrice.validate(true)
            )
                return;

            try {
                this.processing = true;

                const item = this.items.find(
                    (i) => i.description == this.chargeDescription,
                );

                const student = this.getAllStudentList().find(
                    (s) => s.hebName == this.chargeStudent,
                );

                const enrolledStudent = this.getStudents().find(
                    (s) => s.hebName == this.chargeStudent,
                );

                await this.$http.post("api/yk/AddCharge", {
                    user: this.$store.state.authentication.user,
                    regID: this.regID,
                    accountID: this.account.accountID,
                    note: this.chargeNote,
                    dayCampID: enrolledStudent
                        ? enrolledStudent.enrollment.id
                        : null,
                    studentID: student.studentID,
                    invoiceDetail: {
                        itemCode: item.itemCode,
                        description: item.description,
                        quantity: this.chargeQuantity,
                        unitPrice: this.chargePrice,
                        amount: (
                            this.chargeQuantity * this.chargePrice
                        ).toFixed(2),
                        categoryCode: "YKC",
                    },
                });

                this.$notify({
                    text: "Charges Saved",
                    group: "notification",
                    type: "success",
                });

                this.processing = false;
                this.addChargeDialog = false;
                this.refresh();
                fopen;
            } catch (e) {
                this.processing = false;
            }
        },
        // async saveCharges() {
        //     if (
        //         !this.$refs.chargeDescription.validate(true) ||
        //         !this.$refs.chargeAmount.validate(true)
        //     )
        //         return;

        //     try {
        //         this.processing = true;

        //         const student = this.getStudents()[0];

        //         await this.$http.post("api/yk/AddCharge", {
        //             user: this.$store.state.authentication.user,
        //             regID: this.regID,
        //             accountID: this.account.accountID,
        //             description: this.chargeDescription,
        //             amount: this.chargeAmount,
        //             dayCampID: student.enrollment.id,
        //             studentID: student.studentID,
        //         });

        //         this.$notify({
        //             text: "Charges Saved",
        //             group: "notification",
        //             type: "success",
        //         });

        //         this.processing = false;
        //         this.addChargeDialog = false;
        //         this.refresh();
        //     } catch (e) {
        //         this.processing = false;
        //     }
        // },
        validateCall() {
            return [
                this.$refs.from.validate(true),
                this.$refs.to.validate(true),
                this.$refs.internalNumber.validate(true),
            ].every(Boolean);
        },
        cleanPhoneNumber(phoneNumber) {
            if (!phoneNumber) return;

            const value = phoneNumber.trim().replace(/-/g, "");

            return value.length < 11 ? "1" + value : value;
        },
        async makeCall() {
            if (!this.validateCall()) return;

            this.calling = true;

            try {
                await this.$http.post("api/broadcast/makeCall", {
                    from: this.cleanPhoneNumber(this.makeCallDetails.from),
                    to: this.cleanPhoneNumber(this.makeCallDetails.to),
                    callerID: this.cleanPhoneNumber(this.makeCallDetails.from),
                    internalNumber: this.cleanPhoneNumber(
                        this.makeCallDetails.internalNumber,
                    ),
                    accountID: this.account.accountID,
                    username: this.$store.state.authentication.user,
                });

                localStorage.setItem(
                    "user-internal-number",
                    this.cleanPhoneNumber(this.makeCallDetails.internalNumber),
                );

                this.calling = false;
                this.makeCallDialog = false;
            } catch (e) {
                this.calling = false;
            }
        },
        disableAmount(transaction) {
            return transaction.type.includes("Check") &&
                transaction.checkDetails &&
                transaction.checkDetails.length
                ? true
                : false;
        },
        checkAmountChanged(transaction) {
            this.updateChecks(transaction);
        },
        updateChecks(transaction) {
            this.editTransaction.amount = sum(
                transaction.checkDetails.map((s) => +s.amount),
            ).toFixed(2);
        },
        addCheck(transaction) {
            transaction.checkDetails.push({
                date: toISOLocal(new Date(moment())).substr(0, 10),
                amount: 0,
                datePickerMenu: false,
                checkNumber: "CASH",
                transactionID: transaction.transactionID,
            });

            this.updateChecks(transaction);

            this.$forceUpdate();
        },
        removeCheck(index, transaction) {
            transaction.checkDetails.splice(index, 1);

            this.updateChecks(transaction);

            this.$forceUpdate();
        },
        openSendMessageDialog() {
            this.sendMessageDialog = true;
        },
        openEmailMessageDialog() {
            this.emailMessage =
                "\n\n\n<br>" +
                "\n<br>" +
                "\n<br>" +
                `<a href="camp.yksw.org">Access your Account Portal</a>` +
                "\n<br>" +
                "User Name: " +
                this.ykAccount.jlWebUsername +
                "\n<br>" +
                "Password:  " +
                this.ykAccount.jlWebPassword;

            this.sendEmailDialog = true;
        },
        async sendEmailMessage() {
            if (
                !this.$refs.emailTo.validate(true) ||
                !this.$refs.emailFrom.validate(true) ||
                !this.$refs.emailSubject.validate(true)
            )
                return;

            if (!this.emailMessage) {
                this.$notify({
                    text: "Message is Required.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (!this.emailTo) {
                this.$notify({
                    text: "Email To is empty.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (!this.emailFrom) {
                this.$notify({
                    text: "Email From is empty.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.sending = true;

            try {
                await this.$http.post("api/yk/sendEmailMessage", {
                    from: this.emailFrom,
                    subject: this.emailSubject,
                    to: this.emailTo,
                    message: this.emailMessage,
                    isHtml: true,
                    accountID: this.account.accountID,
                });

                this.sending = false;
                this.sendEmailDialog = false;

                this.emailMessage = "";

                this.$notify({
                    text: "Email Sent",
                    group: "notification",
                    type: "success",
                });

                //this.loadMessages();
            } catch (e) {
                this.sending = false;
            }
        },
        async sendMessage() {
            if (!this.message) {
                this.$notify({
                    text: "Message is Required.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            if (!this.messageTo) {
                this.$notify({
                    text: "Please select a 'TO' number.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.sending = true;

            const to = this.messageTo.replaceAll("-", "");

            try {
                await this.$http.post("api/broadcast/sendMessageToAccount", {
                    from: "13473797755",
                    to: to.length == 11 ? to : "1" + to,
                    accountId: this.account.accountID,
                    text: this.message,
                    username: this.$store.state.authentication.user,
                });

                this.newMessage = "";

                this.sending = false;
                this.message = "";
                this.sendMessageDialog = false;

                this.$notify({
                    text: "Message Sent",
                    group: "notification",
                    type: "success",
                });

                //this.loadMessages();
            } catch (e) {
                this.sending = false;
            }
        },
    },
};
</script>
<style>
.v-btn__content {
    color: unset;
}
</style>
